"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRegister = void 0;
var descriptors_1 = require("./descriptors");
/**
 * 静态模块收集器，用于将模块收集起来，初始化DI框架时使用
 */
var ServiceRegister = /** @class */ (function () {
    function ServiceRegister() {
        this.innerRegistry = [];
        this.innerMultiRegistry = [];
    }
    ServiceRegister.prototype.register = function (id, ctor, staticArguments, supportsDelayedInstantiation) {
        // 将模块放入数组
        this.innerRegistry.push([
            id,
            new descriptors_1.SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation),
        ]);
    };
    ServiceRegister.prototype.registerValue = function (id, value) {
        this.innerRegistry.push([id, value]);
    };
    ServiceRegister.prototype.registerMulti = function (id, ctor, staticArguments, supportsDelayedInstantiation) {
        // 将模块放入数组
        this.innerMultiRegistry.push([
            id,
            new descriptors_1.SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation),
        ]);
    };
    ServiceRegister.prototype.registerMultiValue = function (id, value) {
        this.innerMultiRegistry.push([id, value]);
    };
    /**
     * 获取已经收集的模块
     */
    ServiceRegister.prototype.getServiceDescriptors = function () {
        return this.innerRegistry;
    };
    ServiceRegister.prototype.getMulServiceDescriptor = function () {
        return this.innerMultiRegistry;
    };
    return ServiceRegister;
}());
exports.ServiceRegister = ServiceRegister;
//# sourceMappingURL=service-register.js.map